import { render, staticRenderFns } from "./Battlestats.vue?vue&type=template&id=6fa8bc7c&scoped=true&"
import script from "./Battlestats.vue?vue&type=script&lang=js&"
export * from "./Battlestats.vue?vue&type=script&lang=js&"
import style0 from "./Battlestats.vue?vue&type=style&index=0&id=6fa8bc7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa8bc7c",
  null
  
)

export default component.exports